export const defaultConfiguration = {
    titleClosed: 'Напишите нам',
    titleOpen: 'Чем можем помочь?',
    closedStyle: 'chat', // 'button' or 'chat'
    closedChatAvatarUrl: '',
    cookieExpiration: 1,
    introMessage: 'Привет! Задайте любой вопрос — ответим в ближайшее время.',
    autoResponse: 'Спасибо! Мы получили ваше сообщение и скоро ответим.',
    autoNoResponse: 'Сейчас мы недоступны. Оставьте контакт — мы свяжемся с вами.',
    placeholderText: 'Напишите сообщение...',
    displayMessageTime: true,
    mainColor: '#C8FF00',
    headerColor: '#1a1a2e',
    avatarUrl: '',
    operatorStatus: 'Онлайн · Ответим быстро',
    alwaysUseFloatingButton: false,
    desktopHeight: 500,
    desktopWidth: 380,
    visitorPronoun: 'Вы',
    visitorName: ''
};



// WEBPACK FOOTER //
// ./src/widget/default-configuration.js